import { render } from "./search-more-center.vue?vue&type=template&id=516c38eb"
import script from "./search-more-center.vue?vue&type=script&lang=js"
export * from "./search-more-center.vue?vue&type=script&lang=js"

import "./search-more-center.vue?vue&type=style&index=0&id=516c38eb&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-search-bar/template4/search-more-center.vue'],['render',render],['__file',"search-more-center.vue"]])

export default __exports__